module.exports = __webpack_public_path__ + "static_pc/img/33.bbbd7c9c.png";